/**
 * NetworkTooltip
 *
 * 네트워크 노드 호버 툴팁
 * - 아바타
 * - 유저네임
 * - 클릭 안내
 */

import React from 'react';
import { Box, Typography, Avatar, Stack } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';

const NetworkTooltip = ({ node, position }) => {
  if (!node || !position) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: 5, scale: 0.95 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: 5, scale: 0.95 }}
        transition={{ duration: 0.15 }}
        style={{
          position: 'absolute',
          left: position.x + 16,
          top: position.y - 70,
          pointerEvents: 'none',
          zIndex: 1000,
        }}
      >
        <Box
          sx={{
            p: 1.5,
            bgcolor: 'background.paper',
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 2,
            boxShadow: 3,
            minWidth: 140,
          }}
        >
          <Stack direction="row" spacing={1.5} alignItems="center">
            <Avatar
              src={node.avatar}
              sx={{ width: 36, height: 36 }}
            >
              {node.username ? String(node.username).charAt(0).toUpperCase() : '?'}
            </Avatar>
            <Box>
              <Typography variant="body2" fontWeight={600}>
                @{node.username}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Click to view profile
              </Typography>
            </Box>
          </Stack>
        </Box>
      </motion.div>
    </AnimatePresence>
  );
};

export default NetworkTooltip;
